var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2964_136)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2964_136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2964_136)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44115 2.74819C9.1782 2.55692 8.82188 2.55692 8.55893 2.74819L3.75005 6.24554V15C3.75005 15.4142 4.08584 15.75 4.50005 15.75H6.00005V11.25C6.00005 10.0074 7.00742 8.99997 8.25008 8.99997H9.75008C10.9927 8.99997 12.0001 10.0074 12.0001 11.25V15.75H13.5001C13.9143 15.75 14.2501 15.4142 14.2501 15V6.24554L9.44115 2.74819ZM15.7501 7.33645L16.8089 8.10657C17.144 8.35017 17.613 8.27614 17.8566 7.94112C18.1002 7.60609 18.0262 7.13707 17.6912 6.89344L10.3235 1.53508C9.53445 0.961289 8.46563 0.961289 7.6767 1.53508L0.308924 6.89344C-0.0260652 7.13707 -0.100128 7.60609 0.143501 7.94112C0.38713 8.27614 0.856193 8.35017 1.19118 8.10657L2.25005 7.33645V15C2.25005 16.2426 3.25742 17.25 4.50005 17.25H13.5001C14.7427 17.25 15.7501 16.2426 15.7501 15V7.33645ZM10.5001 15.75V11.25C10.5001 10.8357 10.1643 10.5 9.75008 10.5H8.25008C7.83585 10.5 7.50008 10.8357 7.50008 11.25V15.75H10.5001Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2964_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.13af994e9e3dcd9248b339680aa19ce7.svg";
export { ForwardRef as ReactComponent };